// Do not modify manually - generated by `yarn svg:types`

const iconList: IconName[] = [
  'warning-circle',
  'bxs-terminal',
  'bxs-star',
  'bxs-quote-left',
  'bxs-minus-circle',
  'bxs-minus-circle-pricing',
  'bxs-chevron-up',
  'bxs-chevron-up-circle',
  'bxs-chevron-right',
  'bxs-chevron-right-circle',
  'bxs-chevron-left',
  'bxs-chevron-left-circle',
  'bxs-chevron-down',
  'bxs-chevron-down-circle',
  'bxs-checkbox-checked',
  'bxs-check-circle',
  'bxs-check-circle-pricing',
  'bxl-twitter',
  'bxl-linkedin',
  'bxl-linkedin-square',
  'bxl-github',
  'bxl-facebook-square',
  'bxl-facebook-circle',
  'bx-radio-circle',
  'bx-radio-circle-marked',
  'bx-hive',
  'bx-git-repo-forked',
  'bx-envelope',
  'bx-cloud',
  'bx-chevron-up',
  'bx-chevron-right',
  'bx-chevron-left',
  'bx-chevron-down',
  'bx-checkbox',
  'bx-bug-alt',
  'bx-briefcase',
  'bx-arrow-back',
  'bx-analyse',
];

export default iconList;
